import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: "#004F9F",
    gap: theme.spacing(2),
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FFFFFF",
    flexDirection: "column",
  },
  icon: {
    padding: 10,
  },
  text: {
    fontSize: 32,
    fontWeight: "bold",
    font: "Roboto",
    letterSpacing: 0.3,
  },
  loading: {
    color: "#FFFFFF",
    padding: 10,
  },
  selectTicket: {
    minWidth: 400,
    padding: 10,
    margin: 10,
    fontSize: 16,
    fontWeight: "bold",
    font: "Roboto",
    border: "1px solid #004F9F",
  },
  btnSelectTicket: {
    minWidth: 400,
    padding: 10,
    margin: 10,
    fontSize: 16,
    fontWeight: "bold",
    font: "Roboto",
    backgroundColor: "#004F9F",
    color: "#FFFFFF",
    border: "1px solid #FFFFFF",
    borderRadius: 5
  },
  customLink: {
    top: 20,
    right: 20,
    position: 'fixed',
    transition: 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'scale(1.2)',
    },
  }
}));

export default useStyles;